import { buildCsvFromRows } from '../../shared/csv-core/infra/buildCsv';
import type { LibroIvaCompraRow } from './libroIvaComprasTxt';

export type LibroIvaCompraCsvAmounts = {
  neto: number;
  iva: number;
  percepciones: number;
  total: number;
};

export function libroIvaCompraCsvAmounts(row: LibroIvaCompraRow): LibroIvaCompraCsvAmounts {
  const p = row.perceptions;
  const percepciones =
    (p?.iva ?? 0) + (p?.nacionales ?? 0) + (p?.iibb ?? 0) + (p?.municipales ?? 0);
  const b = row.breakdown;
  if (b) {
    const neto = (b.impNeto ?? 0) + (b.impOpEx ?? 0) + (b.impTotConc ?? 0);
    const iva = b.impIva ?? 0;
    return { neto, iva, percepciones, total: neto + iva + percepciones };
  }
  return { neto: 0, iva: 0, percepciones, total: row.amount + percepciones };
}

const csvCell = (value: string | number): string => String(value);

export function buildLibroIvaComprasCsv(rows: LibroIvaCompraRow[]): string {
  const header = [
    'fecha',
    'tipo_cbte',
    'pto_vta',
    'nro_cbte',
    'cuit_proveedor',
    'razon_social',
    'neto',
    'iva',
    'percepciones',
    'total',
  ];

  const dataRows = rows.map((row) => {
    const { neto, iva, percepciones, total } = libroIvaCompraCsvAmounts(row);
    return [
      csvCell(row.expenseDate),
      csvCell(row.invoiceDocType),
      csvCell(row.invoicePv),
      csvCell(row.invoiceNumber),
      csvCell(row.supplierTaxId ?? ''),
      csvCell(row.supplierName ?? ''),
      csvCell(neto.toFixed(2)),
      csvCell(iva.toFixed(2)),
      csvCell(percepciones.toFixed(2)),
      csvCell(total.toFixed(2)),
    ];
  });

  return buildCsvFromRows(header, dataRows);
}
